import { AnyAction } from '@reduxjs/toolkit';
import { FetchLatestVersionRoutine } from '../redux-routines';
import { ILatestVersionData, ILatestVersionState } from '../interfaces';

export type { ILatestVersionState };

const initialState: ILatestVersionState = {
  isFetching: false,
  version: null,
  available: false,
  existing_release_id: null,
  error: null
};

export const latestVersionReducer = (
  state: ILatestVersionState = initialState,
  action: AnyAction
): ILatestVersionState => {
  switch (action.type) {
    case FetchLatestVersionRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };

    case FetchLatestVersionRoutine.SUCCESS: {
      const { version, available, existing_release_id } = action.payload as ILatestVersionData;
      return {
        ...state,
        isFetching: false,
        version,
        available,
        existing_release_id,
        error: null
      };
    }

    case FetchLatestVersionRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};